// extracted by mini-css-extract-plugin
export var root = "S_yb";
export var wrapper = "S_rw";
export var image = "S_yc d_w d_y d_W";
export var imageWithHeight = "S_yd";
export var crop = "S_yf";
export var round = "S_yg";
export var fixedHeight = "S_yh";